(function(){var APR_MUTE="<svg class='ic' viewBox='0 0 24 24' width='1em' height='1em' fill='none' stroke='currentColor' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'><path d='M4 9.5h3.5L12 5.5v13L7.5 14.5H4z'/><path d='m16.5 9.5 4 5M20.5 9.5l-4 5'/></svg>";var APR_SND="<svg class='ic' viewBox='0 0 24 24' width='1em' height='1em' fill='none' stroke='currentColor' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'><path d='M4 9.5h3.5L12 5.5v13L7.5 14.5H4z'/><path d='M16 9.5a4 4 0 0 1 0 5M18.6 7.5a7 7 0 0 1 0 9'/></svg>";function AMBRA_BOOT(){
(function(){if(!document.querySelector('.apr'))return;document.documentElement.classList.add('apr-page');var st=document.createElement('style');st.textContent=".apr__hero-top{display:flex;flex-wrap:wrap;align-items:center;gap:9px;margin-bottom:14px}"+".apr__hero-top .apr__hero-tag{margin:0!important}"+".apr__seal{display:inline-flex;align-items:center;gap:7px;padding:7px 13px;border-radius:30px;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.18);font-size:1.1rem;line-height:1.2;color:rgba(255,255,255,.92);font-weight:700;white-space:nowrap}"+".apx-eyebrow{font-size:1.12rem;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:var(--apr-a);margin-bottom:8px}"+".apx-claim{font-size:clamp(2.4rem,6vw,3.4rem);font-weight:800;line-height:1.1;letter-spacing:-.02em;margin:0 0 10px;color:rgb(var(--color-base-text))}"+".apx-claim em{font-style:normal;color:var(--apr-ad)}"+".apx-sub{font-size:1.42rem;line-height:1.5;color:rgba(var(--color-base-text),.68);margin:0 0 14px}"+".gz__hero-num{text-align:center;margin-bottom:26px}"+".gz__hero-num b{display:block;font-size:clamp(3.4rem,9vw,5.2rem);font-weight:800;line-height:1;color:var(--apr-ad);letter-spacing:-.03em}"+".gz__hero-num span{display:block;font-size:1.5rem;color:rgba(var(--color-base-text),.62);margin-top:8px}"+".gz__stats--2{grid-template-columns:1fr 1fr!important;max-width:520px;margin-left:auto;margin-right:auto}"+".gz__list span b{display:block;font-size:1.42rem;font-weight:700;color:rgb(var(--color-base-text));line-height:1.3}"+".gz__list span small{display:block;font-size:1.12rem;color:rgba(var(--color-base-text),.58);line-height:1.4;margin-top:2px}"+".apr__seal i{font-style:normal;font-size:1.25rem;line-height:1;display:inline-flex;align-items:center}"+".ic{display:block;flex-shrink:0}"+".apr-trust i,.gz__row i,.gz__list i,.gz__chips i,.apr-corte i,.apr__tl-badge{display:inline-flex;align-items:center;justify-content:center}"+".apr-trust i .ic{font-size:1.9rem}.gz__row i .ic{font-size:2rem}.gz__list i .ic{font-size:1.7rem}"+".apr__tl-badge .ic{font-size:1.15rem;margin-right:5px;vertical-align:-.15em}"+".apx-star .ic{font-size:1.35rem;display:inline-block;margin-right:1px}"+".apr__hero-tag .ic{font-size:1.1rem;margin-right:5px;vertical-align:-.12em}"+".apr__ugc-sound .ic{font-size:1.15rem}"+".apr__flag svg{display:block}"+".apr__tag-plus{font-weight:800;opacity:.92}"+".apr__tag-medal{display:inline-flex;align-items:center;font-size:1.25em;line-height:1;margin-left:1px}"+".apr__hero-tag{display:inline-flex;align-items:center;gap:6px;flex-wrap:wrap;line-height:1.35}"+".apr__hero-seals{display:flex;flex-wrap:wrap;gap:8px;margin-top:14px}"+"[id$='__ticker_product']{padding:0!important}"+".horizontal-ticker{padding-top:13px!important;padding-bottom:13px!important}"+".horizontal-ticker span,.horizontal-ticker div,.horizontal-ticker p{font-size:1.32rem!important;letter-spacing:.05em;font-weight:700}"+".apr-corte{display:flex;align-items:center;gap:9px;margin:10px 0 2px;padding:10px 14px;border-radius:12px;background:rgba(184,148,60,.10);border:1px solid rgba(184,148,60,.34);font-size:1.18rem;line-height:1.35;color:#6b4e16}"+".apr-corte i{font-style:normal;font-size:1.25rem;line-height:1}"+".apr-corte b{color:#8a5a00;font-weight:800}"+".apr-fit{display:grid;grid-template-columns:1fr;gap:12px;margin:22px 0 26px}"+".apr-fit__col{padding:20px 18px;border-radius:16px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.13)}"+".apr-fit__col h3{font-size:1.6rem;font-weight:800;margin:0 0 12px;color:#fff}"+".apr-fit__col--si h3{color:#7CE0A8}.apr-fit__col--no h3{color:#F0A48C}"+".apr-fit__col ul{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:9px}"+".apr-fit__col li{position:relative;padding-left:22px;font-size:1.32rem;line-height:1.45;color:rgba(255,255,255,.82)}"+".apr-fit__col--si li::before{content:'\\2713';position:absolute;left:0;color:#7CE0A8;font-weight:800}"+".apr-fit__col--no li::before{content:'\\2715';position:absolute;left:0;color:#F0A48C;font-weight:800}"+".gz__cta{text-align:center;margin-top:26px}"+".gz__cta--mid{margin:0}"+".gz__cta-txt{font-size:1.5rem;margin:0 0 14px;color:rgb(var(--color-base-text))}"+".gz__cta-txt b{font-weight:800;color:var(--apr-ad)}"+".apr__cta--light{background:linear-gradient(135deg,var(--apr-a),var(--apr-ad))!important;color:#fff!important}"+".gz__cta-sub{display:block;margin-top:9px;font-size:1.12rem;color:rgba(var(--color-base-text),.55)}"+".gz--legal{background:rgba(var(--color-base-text),.035)}"+".avl{max-width:720px;margin:0 auto}"+".avl__h{font-size:1.5rem;font-weight:800;margin:0 0 12px;color:rgba(var(--color-base-text),.72);letter-spacing:.01em}"+".avl p{font-size:1.15rem;line-height:1.6;color:rgba(var(--color-base-text),.58);margin:0 0 10px}"+".avl p:last-child{margin-bottom:0}"+".avl b{color:rgba(var(--color-base-text),.78);font-weight:700}"+"[id$='__aviso_legal'] .gz{padding:38px 0!important}"+".apr-inv{display:flex;align-items:center;gap:14px;margin-top:18px;padding:14px 16px;border-radius:16px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.16);color:rgba(255,255,255,.92);max-width:390px}"+".apr-inv svg{flex-shrink:0;color:rgba(255,255,255,.85)}"+".apr-inv__txt{display:flex;flex-direction:column;gap:2px;min-width:0}"+".apr-inv__txt b{font-size:1.05rem;font-weight:800;letter-spacing:.09em;color:rgba(255,255,255,.65)}"+".apr-inv__txt span{font-size:1.5rem;font-weight:800;color:#fff;letter-spacing:.01em}"+".apr-inv__txt em{font-style:normal;font-size:1.05rem;color:rgba(255,255,255,.6);line-height:1.35}"+"@media(max-width:749px){.apr-inv{gap:11px;padding:12px 13px}.apr-inv svg{width:64px;height:64px}.apr-inv__txt span{font-size:1.3rem}}"+"@media(min-width:750px){.apr-fit{grid-template-columns:1fr 1fr;gap:16px}}"+"@media(max-width:749px){.apr__seal{font-size:1.02rem;padding:6px 11px}.horizontal-ticker{padding-top:11px!important;padding-bottom:11px!important}.horizontal-ticker span,.horizontal-ticker div,.horizontal-ticker p{font-size:1.2rem!important}}";document.head.appendChild(st);})();
(function () {
  // The "_rsi-buy-now-button" app injects its own green button via inline
  // style="...!important", which no stylesheet (even with !important) can
  // beat — so we force our color back onto the element's inline style
  // whenever the app (re)writes it.
  function aprColores() {
    var cs = getComputedStyle(document.documentElement);
    var a = (cs.getPropertyValue('--apr-a') || '').trim() || '#8C52FF';
    var ad = (cs.getPropertyValue('--apr-ad') || '').trim() || '#5C2D91';
    return [a, ad];
  }
  function purpleize(el) {
    if (!el) return;
    var c = aprColores();
    el.style.setProperty('background', 'linear-gradient(135deg, ' + c[0] + ' 0%, ' + c[1] + ' 100%)', 'important');
    el.style.setProperty('color', '#fff', 'important');
  }
  function watch(el) {
    purpleize(el);
    new MutationObserver(function () { purpleize(el); })
      .observe(el, { attributes: true, attributeFilter: ['style'] });
  }
  function esBotonCOD(el){
    if(!el) return false;
    var t=(el.textContent||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    return t.indexOf('contra entrega')!==-1 || t.indexOf('contraentrega')!==-1 || t.indexOf('comprar ahora')!==-1;
  }
  function buscarBotones(){
    var out=[];
    var byId=document.getElementById('_rsi-buy-now-button');
    if(byId) out.push(byId);
    var cand=document.querySelectorAll('button,a,[role="button"],[class*="btn"],[class*="button"]');
    for(var i=0;i<cand.length;i++){
      var el=cand[i];
      if(el.closest('[data-apr-scroll]')) continue;
      if(el.querySelector('button,a')) continue;
      if((el.textContent||'').length>70) continue;
      if(esBotonCOD(el) && out.indexOf(el)===-1) out.push(el);
    }
    return out;
  }
  function textoCta(){
    var n=document.getElementById('aprCtaText');
    return n ? (n.textContent||'').trim() : '';
  }
  function setTextoUnico(el,txt){
    var w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null,false);
    var nodos=[],n;
    while(n=w.nextNode()){ if((n.nodeValue||'').trim()) nodos.push(n); }
    if(!nodos.length){ if(el.textContent.trim()!==txt) el.textContent=txt; return; }
    if(nodos[0].nodeValue.trim()!==txt) nodos[0].nodeValue=txt;
    for(var i=1;i<nodos.length;i++){ if(nodos[i].nodeValue.trim()) nodos[i].nodeValue=''; }
  }
  function pintar(el){
    if(!el) return;
    el.setAttribute('data-apr-cod','1');
    var c=aprColores();
    el.style.setProperty('background','linear-gradient(135deg, '+c[0]+' 0%, '+c[1]+' 100%)','important');
    el.style.setProperty('background-color',c[0],'important');
    el.style.setProperty('color','#fff','important');
    el.style.setProperty('border-color','transparent','important');
    var txt=textoCta();
    if(txt) setTextoUnico(el,txt);
  }
  function aplicar(){ buscarBotones().forEach(pintar); }
  aplicar();
  new MutationObserver(aplicar).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class']});
  setTimeout(aplicar,600); setTimeout(aplicar,1600); setTimeout(aplicar,3200);
})();
(function () {
  var track = document.getElementById('aprUgcTrack');
  if (!track) return;
  var items = Array.prototype.slice.call(track.querySelectorAll('.apr__ugc-item'));
  if (!items.length) return;

  /* Carga diferida + autoplay silencioso al entrar en pantalla */
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target.querySelector('video');
        if (!v) return;
        if (e.isIntersecting) {
          if (v.dataset.src && !v.src) v.src = v.dataset.src;
          v.play().catch(function () {});
        } else if (v.muted) {
          v.pause();
        }
      });
    }, { root: track, threshold: 0.25 });
    items.forEach(function (i) { obs.observe(i); });
  } else {
    items.forEach(function (i) {
      var v = i.querySelector('video');
      if (v && v.dataset.src) { v.src = v.dataset.src; v.play().catch(function () {}); }
    });
  }

  /* Arrastre con mouse en escritorio */
  var down = false, sx = 0, ssl = 0;
  track.addEventListener('mousedown', function (e) {
    if (e.target.closest('.apr__ugc-sound')) return;
    down = true; sx = e.clientX; ssl = track.scrollLeft;
    track.style.scrollSnapType = 'none';
    track.classList.add('is-grabbing');
    e.preventDefault();
  });
  document.addEventListener('mousemove', function (e) {
    if (!down) return;
    track.scrollLeft = ssl - (e.clientX - sx);
  });
  document.addEventListener('mouseup', function () {
    if (!down) return;
    down = false;
    track.style.scrollSnapType = '';
    track.classList.remove('is-grabbing');
  });
})();
(function () {
  function vids() { return document.querySelectorAll('.apr video'); }
  function btns() { return document.querySelectorAll('[data-apr-sound]'); }
  function resetAll() {
    vids().forEach(function (v) { v.muted = true; });
    btns().forEach(function (b) {
      b.innerHTML = APR_MUTE;
      b.setAttribute('aria-label', 'Activar sonido');
    });
  }
  btns().forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation(); e.preventDefault();
      var v = b.parentElement.querySelector('video');
      if (!v) return;
      var turnOn = v.muted;
      resetAll();
      if (turnOn) {
        v.muted = false;
        if (v.dataset.src && !v.src) v.src = v.dataset.src;
        v.play().catch(function () {});
        b.innerHTML = APR_SND;
        b.setAttribute('aria-label', 'Silenciar');
      }
    });
  });
})();
(function () {
  /* Los CTAs deben abrir el mismo formulario (EasySell/ReleasIt) que el boton
     de comprar. Como el boton puede venir inyectado por la app con distinto id
     segun la version, probamos varios candidatos en orden y simulamos un clic
     real (pointer + mouse + click), que es lo que algunas apps escuchan. */
  var SELECTORES = [
    '#_rsi-buy-now-button',
    '[id^="_rsi"][id*="buy"]',
    '.rsi-buy-now-button',
    '[data-rsi-buy-now]',
    '.easysell-buy-now',
    '[class*="easysell"][class*="button"]',
    '.product-form__submit',
    'button[name="add"]',
    '.shopify-payment-button__button'
  ];

  function norm(t) {
    return (t || '').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ').trim();
  }

  /* Estrategia principal: el boton de EasySell dice "PAGO CONTRA ENTREGA".
     Buscarlo por su texto visible es mas estable que adivinar ids o clases. */
  var TEXTOS = ['pago contra entrega', 'pagar contra entrega', 'contra entrega', 'contraentrega'];
  function porTexto() {
    var els = document.querySelectorAll('button, a, [role="button"], [class*="btn"], [class*="button"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest('[data-apr-scroll]')) continue;      /* no nuestros propios CTAs */
      if (el.querySelector('button, a')) continue;         /* solo el elemento mas interno */
      var t = norm(el.textContent);
      if (t.length > 70) continue;
      for (var j = 0; j < TEXTOS.length; j++) {
        if (t.indexOf(TEXTOS[j]) !== -1) return el;
      }
    }
    return null;
  }

  function buscar() {
    var marcado = document.querySelector('[data-apr-cod]');
    if (marcado && marcado.offsetParent !== null) return marcado;
    var porT = porTexto();
    if (porT) return porT;
    if (marcado) return marcado;

    for (var i = 0; i < SELECTORES.length; i++) {
      var el = document.querySelector(SELECTORES[i]);
      if (el && el.offsetParent !== null) return el;
    }
    for (var j = 0; j < SELECTORES.length; j++) {
      var e2 = document.querySelector(SELECTORES[j]);
      if (e2) return e2;
    }
    return null;
  }

  function clicReal(el) {
    var tipos = ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'];
    tipos.forEach(function (t) {
      var ev;
      try {
        ev = new MouseEvent(t, { bubbles: true, cancelable: true, view: window });
      } catch (err) {
        ev = document.createEvent('MouseEvents');
        ev.initEvent(t, true, true);
      }
      el.dispatchEvent(ev);
    });
    if (typeof el.click === 'function') { try { el.click(); } catch (e) {} }
  }

  function disparar(intento) {
    var el = buscar();
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { clicReal(el); }, 260);
      return;
    }
    /* La app puede tardar en inyectar su boton: reintentamos brevemente */
    if (intento < 6) {
      setTimeout(function () { disparar(intento + 1); }, 250);
      return;
    }
    var form = document.querySelector('.product-form') || document.querySelector('.price');
    if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-apr-scroll]') : null;
    if (!b) return;
    e.preventDefault();
    disparar(0);
  });
})();


(function(){
  var vids = document.querySelectorAll('.apr video[data-src], .apr video');
  if(!vids.length) return;
  function arranca(v){
    if(v.dataset.src && !v.src) v.src = v.dataset.src;
    v.muted = v.muted !== false ? true : v.muted;
    v.setAttribute('playsinline','');
    v.loop = true;
    var p = v.play(); if(p && p.catch) p.catch(function(){});
  }
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var v = e.target;
        if(e.isIntersecting){ arranca(v); }
        else if(v.muted){ v.pause(); }
      });
    }, {threshold:0.2});
    Array.prototype.forEach.call(vids, function(v){ io.observe(v); });
  } else {
    Array.prototype.forEach.call(vids, arranca);
  }
})();


(function(){
  var DIAS=['domingo','lunes','martes','miercoles','jueves','viernes','sabado'];
  var DIAS_AC=['domingo','lunes','martes','mi\u00e9rcoles','jueves','viernes','s\u00e1bado'];
  var MES=['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  function habil(f,n){
    var d=new Date(f.getTime()), c=0;
    while(c<n){ d.setDate(d.getDate()+1); if(d.getDay()!==0) c++; }
    return d;
  }
  function texto(){
    var hoy=new Date();
    var a=habil(hoy,1), b=habil(hoy,3);
    var t='Llega entre el '+DIAS_AC[a.getDay()]+' '+a.getDate();
    if(a.getMonth()!==b.getMonth()) t+=' de '+MES[a.getMonth()];
    t+=' y el '+DIAS_AC[b.getDay()]+' '+b.getDate()+' de '+MES[b.getMonth()];
    return t;
  }
  function pintar(){
    var t=texto();
    var nodos=document.querySelectorAll('.apr-trust span, .apr-conf__row span, .gb2 span, .codtrio div');
    Array.prototype.forEach.call(nodos,function(n){
      var v=(n.textContent||'').toLowerCase();
      if(v.indexOf('1 a 3 d')!==-1 && v.indexOf('llega')!==-1){ n.textContent=t; n.classList.add('apr-fecha'); }
    });
    var fq=document.querySelectorAll('.fq__a, .apr__ugc-note');
    Array.prototype.forEach.call(fq,function(n){
      if((n.innerHTML||'').indexOf('1 y 3 d')!==-1){
        n.innerHTML=n.innerHTML.replace(/entre <b>1 y 3 d[^<]*<\/b>/i,'<b>'+t.replace('Llega entre el','entre el')+'</b>');
      }
    });
  }
  pintar();
  setTimeout(pintar,800);
})();


(function(){
  function sellos(){
    var tag=document.querySelector('.apr__hero-tag');
    if(!tag || tag.dataset.aprSeal) return;
    tag.dataset.aprSeal='1';
    var t=(tag.textContent||'').trim();
    if(t.toLowerCase().indexOf('materias primas')===-1){
      tag.innerHTML=tag.innerHTML.replace(/(Freddy Ord[^<]*)/,"$1 <b class='apr__tag-plus'>con materias primas premium</b> <i class='apr__tag-medal'><svg class='ic' viewBox='0 0 24 24' width='1em' height='1em' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'><circle cx='12' cy='9' r='5'/><path d='m9 13.4-1.6 6.4 4.6-2.6 4.6 2.6-1.6-6.4'/></svg></i>");
    }
    var badge=document.querySelector('.apr__hero-badge');
    if(badge && !document.querySelector('.apr__hero-seals')){
      var g=document.createElement('div');
      g.className='apr__hero-seals';
      g.innerHTML="<span class='apr__seal'><i class='apr__flag'><svg viewBox='0 0 9 6' width='16' height='11' style='border-radius:2px;display:block' aria-hidden='true'><rect width='9' height='3' fill='#FCD116'/><rect y='3' width='9' height='1.5' fill='#003893'/><rect y='4.5' width='9' height='1.5' fill='#CE1126'/></svg></i>Hecho en Colombia</span>"
        +"<span class='apr__seal'><i><svg class='ic' viewBox='0 0 24 24' width='1em' height='1em' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'><circle cx='10.5' cy='10.5' r='6'/><path d='M15 15l5 5'/></svg></i>Cada lote analizado</span>";
      badge.parentNode.insertBefore(g,badge);
    }
  }
  sellos();
  setTimeout(sellos,500);
})();


(function(){
  function corte(){
    var box=document.querySelector('.apr-conf');
    if(!box || document.querySelector('.apr-corte')) return;
    var h=new Date(), dia=h.getDay(), hora=h.getHours(), t='';
    if(dia===0){ t='Los pedidos de hoy salen mañana lunes'; }
    else if(hora<16){
      var m=16-hora;
      t='Pide antes de las 4:00 pm y <b>sale hoy</b> · quedan '+m+(m===1?' hora':' horas');
    } else { t='Los pedidos de hoy salen mañana a primera hora'; }
    var d=document.createElement('div');
    d.className='apr-corte';
    d.innerHTML="<i><svg class='ic' viewBox='0 0 24 24' width='1em' height='1em' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'><circle cx='12' cy='13' r='7.5'/><path d='M12 9.5V13l2.5 1.5M9.5 3h5'/></svg></i><span>"+t+"</span>";
    box.parentNode.insertBefore(d, box.nextSibling);
  }
  corte();
  setTimeout(corte,600);
})();


(function(){
  function sello(){
    var b=document.querySelector('.apr__hero-badge');
    if(!b || document.querySelector('.apr-inv')) return;
    var t=(b.textContent||'').trim();
    var m=t.match(/((?:NSA|RSA)-[\d-]+)/);
    var num=m?m[1]:'';
    var tipo=t.toLowerCase().indexOf('registro')!==-1?'REGISTRO SANITARIO':'NOTIFICACION SANITARIA';
    var w=document.createElement('div');
    w.className='apr-inv';
    w.innerHTML=
      "<svg viewBox='0 0 120 120' width='84' height='84' aria-hidden='true'>"
      +"<circle cx='60' cy='60' r='56' fill='none' stroke='currentColor' stroke-width='2' opacity='.5'/>"
      +"<circle cx='60' cy='60' r='50' fill='none' stroke='currentColor' stroke-width='1' opacity='.35'/>"
      +"<path d='M60 30 L74 37 v16 c0 12-6 21-14 25-8-4-14-13-14-25V37z' fill='none' stroke='currentColor' stroke-width='2.6' stroke-linejoin='round'/>"
      +"<path d='M52 55 l6 6 12-13' fill='none' stroke='currentColor' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/>"
      +"<text x='60' y='92' text-anchor='middle' font-size='11' font-weight='800' fill='currentColor' letter-spacing='1'>INVIMA</text>"
      +"</svg>"
      +"<div class='apr-inv__txt'><b>"+tipo+"</b><span>"+num+"</span><em>Vigente para su comercializacion en Colombia</em></div>";
    b.parentNode.insertBefore(w,b);
    b.style.display='none';
  }
  sello();
  setTimeout(sello,500);
})();

}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',AMBRA_BOOT);}else{AMBRA_BOOT();}})();